import React from "react";

import { SearchIcon2 } from "../shared/icons";

const SearchBar: React.FC<{
  isShowSearch: boolean;
  setIsShowSearch: (isShowSearch: boolean) => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
}> = ({ isShowSearch, setIsShowSearch, searchValue, setSearchValue }) => {
  return (
    <>
      <div
        className="w-[26px] h-[26px] mr-2 flex items-center justify-center cursor-pointer"
        onClick={() => setIsShowSearch(!isShowSearch)}
        style={{ opacity: isShowSearch ? 0 : 1 }}
      >
        <SearchIcon2 />
      </div>
      {isShowSearch && (
        <div className="w-full lg:max-w-[400px] md:max-w-[320px] max-w-[80%] flex justify-between items-center rounded-full border-[1px] border-[#F05A2A]">
          <input
            type="text"
            placeholder="Search region, TCG, or shop name..."
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            className="w-full outline-none p-2 text-sm md:text-base font-medium bg-transparent"
          />

          <button className="flex items-center justify-center p-1.5 rounded-full cursor-pointer">
            <SearchIcon2 />
          </button>
        </div>
      )}
    </>
  );
};

export default SearchBar;
